import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=603c2028&scoped=true&"
import script from "./Information.vue?vue&type=script&lang=ts&"
export * from "./Information.vue?vue&type=script&lang=ts&"
import style0 from "./Information.vue?vue&type=style&index=0&id=603c2028&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603c2028",
  null
  
)

export default component.exports